module.exports = __webpack_public_path__ + "static/media/relaxmit-logo.167d26ef.png";